export default "__VITE_ASSET__D1SXp_wz__"